import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ConfirmDialog from './common/ConfirmDialog';

const SessionExpiredDialog: React.FC = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  // Lytteren registreres én gang, så den leser user gjennom en ref og ser verdien når
  // hendelsen kommer. useLayoutEffect oppdaterer ref-en i samme commit som ny user.
  const userRef = useRef(user);
  useLayoutEffect(() => {
    userRef.current = user;
  }, [user]);

  useEffect(() => {
    // Uten innlogget bruker er 401 ikke en utløpt sesjon: en ny besøkende får 401 fra
    // oppstartssjekken /auth/me, og en utlogget bruker har ingen sesjon å miste.
    const handler = () => {
      if (userRef.current) setOpen(true);
    };
    window.addEventListener('session-expired', handler as EventListener);
    return () => window.removeEventListener('session-expired', handler as EventListener);
  }, []);

  const handleConfirm = async () => {
    setOpen(false);
    try { await logout(); } catch {}
    navigate('/login');
  };

  return (
    <ConfirmDialog
      open={open}
      title="Sesjonen er utløpt"
      message="Du har vært inaktiv en stund, eller sesjonen er utløpt. Logg inn på nytt for å fortsette."
      confirmText="OK"
      cancelText="Avbryt"
      onConfirm={handleConfirm}
      onCancel={() => setOpen(false)}
    />
  );
};

export default SessionExpiredDialog;
